export default __webpack_public_path__ + "static/portfolio-25-60e6d125aa035aac8c63be4b046515c1.jpg";